import * as tslib_1 from "tslib";
import { LocalEditService } from './local-edit.service';
/**
 * @hidden
 */
var LocalRowEditService = /** @class */ (function (_super) {
    tslib_1.__extends(LocalRowEditService, _super);
    function LocalRowEditService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalRowEditService.prototype.update = function (_item) {
        this.dataChanged();
    };
    return LocalRowEditService;
}(LocalEditService));
export { LocalRowEditService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/editing-directives/local-row-edit.service.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/editing-directives/local-row-edit.service.js
// module chunks = vendor